import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MultipleInputDialogData } from 'src/app/interfaces/multiple-input-dialog-data.interface';

@Component({
  selector: 'app-multiple-input-dialog',
  templateUrl: './multiple-input-dialog.component.html',
  styleUrl: './multiple-input-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatFormField, MatLabel, MatInput, FormsModule, MatDialogActions, MatButton],
})
export class MultipleInputDialogComponent {
  dialog_ref = inject<MatDialogRef<MultipleInputDialogComponent>>(MatDialogRef);
  data = inject<MultipleInputDialogData>(MAT_DIALOG_DATA);

  value: { [key: string]: string } = {};

  submit() {
    if (this.data.inputs.some(input => input.required && this.value[input.slug])) {
      this.dialog_ref.close(this.value);
    }
  }
}
